import { ResponseError } from 'api-client';

export const billingErrorMessage = async (error: unknown): Promise<string> => {
  if (error instanceof ResponseError) {
    if ([401, 403, 404].includes(error.response.status)) return 'Billing is not available for this team or account.';
    try {
      const body: unknown = await error.response.clone().json();
      if (typeof body === 'object' && body !== null && 'error' in body && typeof body.error === 'string')
        return body.error;
      if (typeof body === 'object' && body !== null && 'detail' in body && typeof body.detail === 'string')
        return body.detail;
    } catch {
      /* The generic retry message covers non-JSON error responses. */
    }
  }
  return 'Billing is temporarily unavailable. Please try again.';
};
